import { Form, FormLayout, Modal, TextField } from '@shopify/polaris';
import { useField, useForm } from '@shopify/react-form';
import __helpers from 'helpers/index';
import __ from 'languages/index';
import { useMutateUpdateInvoice, useGetInvoice } from 'queries/invoices.query';
import { useEffect } from 'react';

export default function InvoiceEditModal({ invoice_id, show, onClose }: { invoice_id: bigint; show: boolean; onClose: () => void }) {
  const { data: entity } = useGetInvoice(invoice_id);
  const { mutateAsync: updateEntity, isPending: updating } = useMutateUpdateInvoice();

  const useFields = {
    shDon: useField<string>({
      value: entity?.shDon ?? '',
      validates: [
        (inputValue) => {
          if (!__helpers.isNumeric(inputValue)) {
            return 'Phải là một số hợp lệ!';
          }
        },
      ],
    }),
    mccqt: useField<string>({
      value: entity?.mccqt ?? '',
      validates: [],
    }),
    khhDon: useField<string>({
      value: entity?.khhDon ?? '',
      validates: [],
    }),
  };

  const { fields, submit, dirty } = useForm({
    fields: useFields,

    async onSubmit(values) {
      try {
        await updateEntity({
          invoice_id: String(invoice_id),
          shDon: values.shDon,
          mccqt: values.mccqt,
          khhDon: values.khhDon,
        });
        onClose();
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            useFields[e.params.field].setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success' };
    },
  });

  useEffect(() => {
    if (!show) {
      __helpers.resetForm(useFields);
    }
  }, [show]);

  return (
    <Modal
      open={show}
      onClose={() => onClose()}
      title={`Cập nhật hóa đơn số ${entity?.shDon}`}
      primaryAction={{
        content: 'Cập nhật',
        disabled: !dirty,
        loading: updating,
        onAction: submit,
      }}
      secondaryActions={[
        {
          content: 'Close',
          onAction: () => onClose(),
        },
      ]}
    >
      <Modal.Section>
        <Form onSubmit={submit}>
          <FormLayout>
            <TextField
              autoFocus
              autoComplete="off"
              label="Số hóa đơn nếu điều chỉnh"
              {...fields.shDon}
              helpText={'Không nên thay số hóa đơn trừ khi nó được điều chỉnh sang hóa đơn khác, gọi là số hóa đơn thay thế.'}
            />
            <TextField autoComplete="off" label="Ký hiệu hóa đơn" {...fields.khhDon} helpText={'Nếu bạn không biết đây là gì, đừng cập nhật nó.'} />
            <TextField
              label="Mã tiếp nhận của cơ quan thuế"
              autoComplete="off"
              {...fields.mccqt}
              helpText={'Là mã cơ quan thuế tiếp nhận và trả về qua API.'}
            />
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
}

